import { render, staticRenderFns } from "./studentCheck.vue?vue&type=template&id=00a60975&"
import script from "./studentCheck.vue?vue&type=script&lang=js&"
export * from "./studentCheck.vue?vue&type=script&lang=js&"
import style0 from "./studentCheck.vue?vue&type=style&index=0&id=00a60975&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports